import { render, staticRenderFns } from "./EditorPopover.vue?vue&type=template&id=4d94ea89&"
import script from "./EditorPopover.vue?vue&type=script&lang=js&"
export * from "./EditorPopover.vue?vue&type=script&lang=js&"
import style0 from "./EditorPopover.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports